import axiosInstance from './axiosInstance';
import { variables } from './variables';

const API_URL = variables.EMAIL_API;
const EMAIL_ADMIN_API = variables.EMAIL_ADMIN_API;

const userApi = {
  // Get all users with optional pagination and filtering
  getUsers: () => {
    return axiosInstance.get(`${API_URL}`);
  },
  // Trigger server-side sync of user table
  syncUserTable: async () => {
    // POST to Admin/SyncUserTable
    return axiosInstance.post(`${variables.ADMIN_API}/SyncUserTable`);
  },
  updateEmailInvite: async (payload) => {
    // payload: { id, customerNumber, inviteSent }
    return axiosInstance.put(`${EMAIL_ADMIN_API}/Update`, payload);
  }
};

export default userApi;